import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent } from '../utils/analytics';

// Custom hook for Google Analytics
export const useAnalytics = () => {
    const location = useLocation();

    // Track page views automatically
    useEffect(() => {
        trackPageView(location.pathname);
    }, [location]);

    // Return tracking functions for components to use
    return {
        trackEvent,
        trackPageView: () => trackPageView(location.pathname),
    };
};

// Hook for tracking specific events
export const useEventTracking = () => {
    return {
        trackFormSubmission: (formName) => trackEvent('form_submit', 'engagement', formName),
        trackPhoneCall: (phoneNumber) => trackEvent('phone_call', 'engagement', phoneNumber),
        trackServiceInquiry: (serviceName) => trackEvent('service_inquiry', 'engagement', serviceName),
        trackButtonClick: (buttonName, location) => trackEvent('button_click', 'engagement', `${buttonName}_${location}`),
        trackScrollDepth: (depth) => trackEvent('scroll_depth', 'engagement', depth),
        trackTimeOnPage: (timeSpent) => trackEvent('time_on_page', 'engagement', timeSpent),
    };
};
